import PropTypes from 'prop-types';
import React from 'react';
import CommonLoader from '../../Common/Loader';
import CartFooter from './CartFooter';
import CartItem from './CartItem';
// import { hasFrameOnlyProduct } from '../../../../utils/helper';
import Customevent from '../../../../utils/Customevent';
import './Cart.scss';
import './CartItems.scss';

class CartItems extends React.PureComponent {
  static propTypes = {
    isCartLoader: PropTypes.any,
    section: PropTypes.string,
    isAlreadyLoyal: PropTypes.bool,
    cartObj: PropTypes.object,
    dtmStateLoad: PropTypes.func,
    redisCommonData: PropTypes.object,
    checkoutLoaderFunc: PropTypes.func,
    checkoutLoader: PropTypes.bool,
    cartActions: PropTypes.object,
    isframeProduct: PropTypes.bool,
  };

  constructor(props, context) {
    super(props, context);
    if (this.props.redisCommonData) {
      const checkout = this.props.redisCommonData.CONFIG_CTA_DESKTOP
        ? JSON.parse(this.props.redisCommonData.CONFIG_CTA_DESKTOP)
        : '';
      this.checkoutCTA = checkout.CHECKOUT;
    }
  }

  componentDidMount() {
    const { cartObj, redisCommonData, isAlreadyLoyal } = this.props;
    const pageInfo = `${document.location.pathname}${document.location.search} |time:  Date()`;
    const loyaltyConfig =
      redisCommonData &&
      redisCommonData.LOYALTY_CONFIG &&
      JSON.parse(redisCommonData.LOYALTY_CONFIG);
    _gaq.push(['_trackEvent', 'A2C Popup', 'Render Main Cart', `page: ${pageInfo}`]);
    _gaq.push(['ninja._trackEvent', 'A2C Popup', 'Render Main Cart', `page: ${pageInfo}`]);
    // Removing GV in checkout step 3 componentwillunmount
    // cartObj.totals.discounts.forEach(data => {
    //     if (data.type === 'gv') {
    //         cartActions.applyCode(config.apiPath.applyGV + data.code, 'delete');
    //     }
    // });
    /* Remove This ASAP */
    const isLoyaltyBrand =
      (loyaltyConfig && loyaltyConfig.brandsAllowed) || 'Vincent Chase,John Jacobs';
    let isLoyaltyProductAdded = false;
    let isLoyaltySunglass = false;
    if (cartObj && cartObj.items.length) {
      cartObj.items.forEach(item => {
        if (item.classification === 'loyalty_services') {
          isLoyaltyProductAdded = true;
        }
        if (
          'sunglasses'.indexOf(item.classification) > -1 &&
          isLoyaltyBrand.indexOf(item.brandName) > -1
        ) {
          isLoyaltySunglass = true;
        }
      });
    }

    const event = new Customevent('cartPopupOpened', {
      detail: {
        isAlreadyLoyal,
        isLoyaltyProductAdded,
        loyaltyPid: (loyaltyConfig && loyaltyConfig.goldPid) || '128269',
        isLoyaltySunglass,
      },
    });
    event.dispatch();
    // const isframeProduct = hasFrameOnlyProduct(cartObj.items);
    // cartActions.frameOnlyProduct({ isframeProduct });
  }

  cartCondition = data => {
    return (
      data.classification === 'services' ||
      data.classification === 'loyalty_services' ||
      data.classification === 'contact_lens' ||
      data.classification === 'contact_lens_solution'
    );
  };

  deleteCartItem = data => {
    const { cartActions, dtmStateLoad, section } = this.props;
    cartActions.updateCartItem(data.id, 0, 'delete');
    let pageName = '';
    if (section === 'prod') {
      pageName = 'Product';
    } else {
      pageName = 'Category';
    }
    if (window.dtm.LenskartRewamp) {
      window.dtm.LenskartRewamp.slideCart.click.removeItemProduct(data, pageName);
    }
    sessionStorage.setItem('cartItem', 'delete');
    sessionStorage.setItem('dtmOnLoadData', 'cartSummary');
    dtmStateLoad(false);
  };

  decrementItem = data => {
    const { cartActions, dtmStateLoad, section } = this.props;
    cartActions.updateCartItem(data.id, 1, 'decrease');
    sessionStorage.setItem('cartItem', 'decrease');
    sessionStorage.setItem('dtmOnLoadData', 'cartSummary');
    dtmStateLoad(false);
    let pageName = '';
    if (section === 'prod') {
      pageName = 'Product';
    } else {
      pageName = 'Category';
    }
    if (window.dtm.LenskartRewamp) {
      window.dtm.LenskartRewamp.slideCart.click.removeItemProduct(data, pageName);
    }
  };

  incrementItem = data => {
    const { cartActions, dtmStateLoad } = this.props;
    const { price } = data;
    cartActions.updateCartItem(data.id, 1, 'increase');
    sessionStorage.setItem('cartItem', 'increase');
    dtmStateLoad(true);
    window.ReactPixel.default.track('AddToCart', {
      content_type: 'product',
      content_ids: data?.productId,
      value: price?.value,
      content_name: data?.classification,
      currency: price?.currencyCode,
    });
    if (window.dtm.LenskartRewamp) {
      window.dtm.LenskartRewamp.slideCart.click.incrementItemProduct(data);
    }
  };

  bogoOffer = () => {
    let pageNameValue = '';
    if (this.props.section === 'prod') {
      pageNameValue = 'Product';
    } else {
      pageNameValue = 'Category';
    }
    if (window.dtm.LenskartRewamp) {
      window.dtm.LenskartRewamp.slideCart.click.bogoOffer(pageNameValue);
    }
  };

  fnMimimizeLoyalty = addOrSkip => {
    const { redisCommonData } = this.props;
    const loyaltyConfig =
      redisCommonData &&
      redisCommonData.LOYALTY_CONFIG &&
      JSON.parse(redisCommonData.LOYALTY_CONFIG);
    if (addOrSkip === 'add-membership') {
      const obj = {};
      obj.productId = (loyaltyConfig && loyaltyConfig.goldPid) || '128269';
      this.props.cartActions.addToCart(obj);
      this.props.hideHandler();
    }
    document.getElementsByClassName('cart-popup_slide')[0].style.top = '';
    document.getElementsByClassName('cart-popup_slide')[0].style.marginTop = '';
  };

  render() {
    const { redisCommonData, cartObj, isframeProduct, dataLocale, currencyMark, localeInfo, login } =
      this.props;
    const currencyCode =
      cartObj && cartObj.currencyCode ? cartObj.currencyCode : dataLocale.CURRENCY_CODE;
    const currencySymbol = currencyMark[currencyCode];
    const {
      ORDER_TOTAL,
      NET_AMOUNT,
      TAX_COLLECTED,
      PART_TAX_COLLECTED,
      CONVENIENCE_FEES,
      FREE,
      EXTRA_DISCOUNT,
      SUBTOTAL /* , ADD_TO_CART: loyaltyAddToCartText, SKIP: loyaltySkipBtnText, GOLD_TNC_HTML: loyaltyTCHtml, GOLD_CART_HOVER_HTML: loyaltyHoverHtml */,
    } = dataLocale || {};
    const loyaltyConfig =
      redisCommonData &&
      redisCommonData.LOYALTY_CONFIG &&
      JSON.parse(redisCommonData.LOYALTY_CONFIG);
    let isLoyaltyProductAdded = false;
    const {
      classificationsAllowed: isLoyaltyClsfn = 'eyeframe',
      brandsAllowed: isLoyaltyBrand = 'Vincent Chase,John Jacobs',
    } = loyaltyConfig || {};
    let isProductLoyaltyEnabled = false;
    return (
      <div className="cart-content crt-prd-block">
        <div style={{ maxHeight: '272px', overflow: 'auto' }}>
          {cartObj.items.map((data, key) => {
            if (!isLoyaltyProductAdded && data.classification === 'loyalty_services') {
              isLoyaltyProductAdded = true;
            }
            if (
              isLoyaltyClsfn.indexOf(data.classification) > -1 &&
              isLoyaltyBrand.indexOf(data.brandName) > -1
            ) {
              if (!isProductLoyaltyEnabled) {
                isProductLoyaltyEnabled = true;
              }
            }
            return (
              <div key={key} className="chkout-cart-region row-fluid">
                {this.props.isCartLoader && <CommonLoader />}
                <CartItem
                  currencyMark={currencyMark}
                  data={data}
                  dataLocale={dataLocale}
                  decrementItem={() => {
                    this.decrementItem(data);
                  }}
                  deleteCartItem={() => {
                    this.deleteCartItem(data);
                  }}
                  incrementItem={() => {
                    this.incrementItem(data);
                  }}
                  index={key}
                  localeInfo={localeInfo}
                  login={login}
                />
              </div>
            );
          })}
        </div>
        <div className="row-fluid pyment-crt-blck overflow-visible">
          <table className="row-fluid payment-crt-tb">
            <tbody>
              <tr>
                <td>
                  <div className="pric-hedng text-capitalize">{SUBTOTAL}</div>
                  <div>
                    {currencySymbol}
                    {cartObj.totals.subTotal}
                    <div></div>
                  </div>
                </td>
                {cartObj.totals.totalDiscount > 0 && (
                  <td>
                    <i className="icon- icn sgnminus"></i>
                  </td>
                )}
                {cartObj.totals.totalDiscount > 0 && (
                  <td>
                    <div className="pric-hedng">
                      {EXTRA_DISCOUNT}
                      {cartObj.discountDescription && (
                        <span id="discount-cart">
                          <i className="icon- mob-icon-question-mark tip">
                            <span className="discount-cont">
                              {cartObj.discountDescription}
                              <span className="discount-arrow"></span>
                            </span>
                          </i>
                        </span>
                      )}
                    </div>
                    <div>
                      <span>
                        {currencySymbol}
                        {cartObj.totals.totalDiscount}
                      </span>
                    </div>
                  </td>
                )}
                {cartObj.totals.totalDiscount > 0 && (
                  <td>
                    <div className="pls-crt-sign">=</div>
                  </td>
                )}
                {cartObj.totals.totalDiscount === 0 && (
                  <td>
                    <i className="icon- icn fs20 font-style-normal">=</i>
                  </td>
                )}
                <td>
                  <div className="pric-hedng">{NET_AMOUNT}</div>
                  <div>
                    <span>
                      {currencySymbol}
                      {(cartObj.totals.subTotal - cartObj.totals.totalDiscount)
                        .toString()
                        .indexOf('.') !== -1
                        ? (cartObj.totals.subTotal - cartObj.totals.totalDiscount).toFixed(2)
                        : cartObj.totals.subTotal - cartObj.totals.totalDiscount}
                    </span>
                  </div>
                </td>
                {cartObj.totals.totalTax > 0 && (
                  <td>
                    <i className="icon- icn sgnplus"></i>
                  </td>
                )}
                {cartObj.totals.totalTax > 0 && (
                  <td>
                    <div className="pric-hedng">
                      {TAX_COLLECTED}.
                      <span id="discount-cart">
                        <i className="icon- mob-icon-question-mark tip discount-cart">
                          <span className="discount-cont">
                            {PART_TAX_COLLECTED}
                            <span className="discount-arrow"></span>
                          </span>
                        </i>
                      </span>
                    </div>
                    <div>
                      {currencySymbol}
                      {cartObj.totals.totalTax}
                    </div>
                  </td>
                )}
                <td>
                  <i className="icon- icn sgnplus"></i>
                </td>
                <td>
                  <div className="pric-hedng">{CONVENIENCE_FEES}</div>
                  <div>
                    {cartObj.totals.shipping > 0 ? (
                      <span>
                        {currencySymbol}
                        {cartObj.totals.shipping}
                      </span>
                    ) : (
                      <span>{FREE}</span>
                    )}
                  </div>
                </td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
        </div>
        <div className="row-fluid f23">
          <div className="span6 upy-block">
            <span className="span6">{ORDER_TOTAL} :</span>
            <span className="span6 color-yellow text-left">
              {currencySymbol}
              {cartObj.totals.total}
            </span>
          </div>
          <div className={`finl-cart-conti span6 ${this.checkoutCTA ? 'custom-checkoutBtn' : ''}`}>
            <CartFooter
              checkOutHandler={() => {
                this.props.checkoutLoaderFunc(true);
                _gaq.push(
                  ['_trackEvent', 'Place Order', 'Cod'],
                  ['ninja._trackEvent', 'Place Order', 'Cod']
                );
              }}
              checkoutCTA={this.checkoutCTA}
              checkoutLoader={this.props.checkoutLoader}
              dataLocale={dataLocale}
              isframeProduct={isframeProduct}
            />
          </div>
        </div>
      </div>
    );
  }
}

CartItems.defaultProps = {
  redisCommonData: {},
  cartObj: {},
};

export default CartItems;
